import React from 'react';
import { Select } from 'antd';
import { CatalogDetail } from '../../../apis/detail-catalog';
import { SectionDetails } from './section-details';
import styles from '../styles.module.css';

interface LocationSectionProps {
  departmentSections: CatalogDetail['departmentSections'];
  selectedCity: string | undefined;
  selectedSection: string | undefined;
  onCityChange: (value: string) => void;
  onSectionChange: (value: string) => void;
}

export const LocationSection: React.FC<LocationSectionProps> = ({
  departmentSections,
  selectedCity,
  selectedSection,
  onCityChange,
  onSectionChange,
}) => {
  const cities = Array.from(
    new Set(departmentSections?.map((section) => section.city) || [])
  );

  const filteredSections = selectedCity
    ? departmentSections?.filter((section) => section.city === selectedCity)
    : [];

  return (
    <div className={styles.locationSection}>
      <h2>Buscar local de atendimento</h2>
      <div className={styles.locationInputs}>
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            Selecione o município de atendimento
          </label>
          <Select
            placeholder="Selecione..."
            className={styles.select}
            value={selectedCity}
            onChange={onCityChange}
            options={cities.map((city) => ({
              value: city,
              label: city,
            }))}
          />
        </div>
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            Selecione a unidade de atendimento
          </label>
          <Select
            placeholder="Selecione..."
            className={styles.select}
            value={selectedSection}
            onChange={onSectionChange}
            disabled={!selectedCity}
            options={filteredSections?.map((section) => ({
              value: section.id,
              label: section.name,
            }))}
          />
        </div>
      </div>
      {selectedSection && (
        <div className={styles.sectionDetails}>
          {filteredSections?.map((section) => {
            if (section.id === selectedSection) {
              return <SectionDetails key={section.id} section={section} />;
            }
            return null;
          })}
        </div>
      )}
    </div>
  );
};
